// Enumeração centralizadas de etapas do onboarding
// Escalável e fácil de manter para futuras expansões

export const ONBOARDING_STEPS = {
  // Fluxo Básico - 5 etapas principais
  COMPANY: "company",
  FIRST_CLIENT: "first_client",
  FIRST_QUOTE: "first_quote",
  QUOTE_PDF_VIEWED: "quote_pdf_viewed",
  FIRST_ORDER: "first_order",

  // Evolução - próximas etapas (para "Evolua seu Ateliê")
  FIRST_PRODUCTS: "first_products",
  FIRST_SERVICES: "first_services",
  CREATE_ORDER: "create_order",
  FIRST_NF: "first_nf",
  FIRST_TEAM_MEMBER: "first_team_member",
} as const;

export type OnboardingStep = typeof ONBOARDING_STEPS[keyof typeof ONBOARDING_STEPS];

// Etapas do fluxo básico (primeira vez)
export const BASIC_ONBOARDING_STEPS: OnboardingStep[] = [
  ONBOARDING_STEPS.COMPANY,
  ONBOARDING_STEPS.FIRST_CLIENT,
  ONBOARDING_STEPS.FIRST_QUOTE,
  ONBOARDING_STEPS.QUOTE_PDF_VIEWED,
  ONBOARDING_STEPS.FIRST_ORDER,
];

// Etapas de evolução (após completar o fluxo básico)
export const EVOLUTION_ONBOARDING_STEPS: OnboardingStep[] = [
  ONBOARDING_STEPS.FIRST_PRODUCTS,
  ONBOARDING_STEPS.FIRST_SERVICES,
  ONBOARDING_STEPS.CREATE_ORDER,
  ONBOARDING_STEPS.FIRST_NF,
  ONBOARDING_STEPS.FIRST_TEAM_MEMBER,
];

// Mapear etapas para descrições e ícones
export const STEP_CONFIG: Record<OnboardingStep, {
  title: string;
  description: string;
  route?: string;
  isOptional?: boolean;
  requiresPlan?: "trial" | "basic" | "professional";
}> = {
  [ONBOARDING_STEPS.COMPANY]: {
    title: "Configure sua empresa",
    description: "Personalize seus documentos com a identidade do seu ateliê.",
    route: "/configuracoes/empresa",
  },
  [ONBOARDING_STEPS.FIRST_CLIENT]: {
    title: "Cadastre seu primeiro cliente",
    description: "Comece a construir sua carteira de clientes.",
    route: "/clientes",
  },
  [ONBOARDING_STEPS.FIRST_QUOTE]: {
    title: "Crie seu primeiro orçamento",
    description: "Monte um orçamento profissional em poucos minutos.",
    route: "/orcamentos/novo",
  },
  [ONBOARDING_STEPS.QUOTE_PDF_VIEWED]: {
    title: "Veja como seu cliente receberá o orçamento",
    description: "Clique em Imprimir para visualizar exatamente como seu cliente receberá o orçamento.",
  },
  [ONBOARDING_STEPS.FIRST_ORDER]: {
    title: "Aprove seu primeiro orçamento",
    description: "Veja como um orçamento aprovado se transforma automaticamente em um pedido.",
  },
  [ONBOARDING_STEPS.FIRST_PRODUCTS]: {
    title: "Cadastrar produtos no catálogo",
    description: "Crie um catálogo de produtos para facilitar a criação de orçamentos e pedidos.",
    route: "/catalogo",
    isOptional: true,
  },
  [ONBOARDING_STEPS.FIRST_SERVICES]: {
    title: "Cadastrar serviços",
    description: "Configure os serviços que você oferece.",
    route: "/servicos",
    isOptional: true,
  },
  [ONBOARDING_STEPS.CREATE_ORDER]: {
    title: "Crie seu primeiro pedido",
    description: "Aprenda como criar pedidos diretos sem usar orçamentos.",
    route: "/pedidos",
    isOptional: false,
  },
  [ONBOARDING_STEPS.FIRST_NF]: {
    title: "Emitir primeira Nota Fiscal",
    description: "Configure e emita sua primeira nota fiscal.",
    route: "/notas-fiscais",
    isOptional: true,
    requiresPlan: "professional",
  },
  [ONBOARDING_STEPS.FIRST_TEAM_MEMBER]: {
    title: "Criar novo operador",
    description: "Adicione sua primeira pessoa na equipe do Ateliê Pro.",
    route: "/configuracoes/usuarios",
    isOptional: true,
    requiresPlan: "professional",
  },
};
